/* =========================================================
   SNS CART — SUGGESTED PRODUCTS
   Stable Drawer + Refresh + Re-render Loading
   ========================================================= */

async function loadSuggestedProducts() {

  console.log("SNS: Loading suggested products...");

  const slider = document.getElementById("sns-product-slider");

  if (!slider) {
    console.log("SNS: Slider not found");
    return;
  }

  try {

    slider.innerHTML = "";

    const cartResponse = await fetch("/cart.js", {
      cache: "no-store"
    });

    const cart = await cartResponse.json();

    const cartHandles = cart.items.map(item => item.handle);

    const handles = [
      "white-oud-rose-lavender-perfume",
      "armour-365-cinnamon-musk-perfume",
      "secret-citrus-bergamot-perfume",
      "signature-leather-cedarwood-perfume",
      "men-impression-grapefruit-perfume"
    ];

    for (const handle of handles) {

      if (cartHandles.includes(handle)) {
        continue;
      }

      try {

        const res = await fetch(`/products/${handle}.js`, {
          cache: "no-store"
        });

        if (!res.ok) continue;

        const product = await res.json();

        const comparePrice = product.compare_at_price || 0;
        const salePrice = product.price || 0;

        const reviewData =
  window.SNSJudgeMeRatings?.[product.handle];

const rating = Number(reviewData?.rating || 0);
const reviewCount = Number(reviewData?.count || 0);

const fullStars = Math.max(
  0,
  Math.min(5, Math.round(rating))
);

const stars =
  "★".repeat(fullStars) +
  "☆".repeat(5 - fullStars);

const ratingHTML =
  reviewCount > 0
    ? `
      <div class="sns-product-rating">
        <span class="sns-rating-stars">${stars}</span>
        <span class="sns-rating-count">(${reviewCount})</span>
      </div>
    `
    : "";

        let savingHTML = "";

        if (comparePrice > salePrice) {

          const saveAmount =
            ((comparePrice - salePrice) / 100).toFixed(0);

          const savePercent =
            Math.round(
              ((comparePrice - salePrice) / comparePrice) * 100
            );

          savingHTML = `
            <div class="sns-saving">
              🔥 Save ₹${saveAmount} • ${savePercent}% OFF
            </div>
          `;
        }

        let badge = "";

        const sellingFast = [
          "white-oud-rose-lavender-perfume",
          "secret-citrus-bergamot-perfume",
          "armour-365-cinnamon-musk-perfume",
          "signature-leather-cedarwood-perfume",
          "men-impression-grapefruit-perfume"
        ];

        if (sellingFast.includes(product.handle)) {

          badge = `
            <div class="sns-stock-badge">
              🔥 SELLING FAST
            </div>
          `;
        }

        slider.insertAdjacentHTML("beforeend", `
          <div class="sns-product-card">

            <div class="sns-badge">
              🔥 BEST SELLER
            </div>

            
            <a
              href="/products/${product.handle}"
              class="sns-product-image"
            >
              <img
                src="${product.featured_image}"
                alt="${product.title}"
                loading="lazy"
              >
              ${badge}
            </a>

            <div class="sns-product-title">
              ${product.title}
            </div>

            ${ratingHTML}

            <div class="sns-product-price">

              ${
                product.compare_at_price > product.price
                  ? `
                    <span class="sns-old-price">
                      ₹${(product.compare_at_price / 100).toFixed(0)}
                    </span>
                  `
                  : ""
              }

              <span class="sns-sale-price">
                ₹${(product.price / 100).toFixed(0)}
              </span>

            </div>
            
            <div class="sns-cart-action">

              <button
                type="button"
                class="sns-add-btn"
                data-id="${product.variants[0].id}"
              >
                <span class="sns-btn-text">
                  + Add
                </span>
              </button>
              <div class="sns-saving-wrap">
                ${savingHTML}
                  </div>

              <div
                class="sns-qty-box"
                data-id="${product.variants[0].id}"
              >
                <button
                  type="button"
                  class="sns-minus"
                >
                  -
                </button>

                <span class="sns-qty">
                  1
                </span>

                <button
                  type="button"
                  class="sns-plus"
                >
                  +
                </button>

              </div>

            </div>

          </div>
        `);

      } catch (productError) {

        console.error(
          "SNS: Product loading failed:",
          handle,
          productError
        );

      }

    }

    console.log(
      "SNS: Suggested products loaded:",
      slider.children.length
    );

  } catch (error) {

    console.error(
      "SNS: Recommendation loading failed:",
      error
    );

  }
}


/* =========================================================
   INITIAL PAGE LOAD
   ========================================================= */

document.addEventListener("DOMContentLoaded", () => {

  loadSuggestedProducts();

});


/* =========================================================
   ADD SUGGESTED PRODUCT TO CART
   ========================================================= */

document.addEventListener("click", async (e) => {

  const button = e.target.closest(".sns-add-btn");

  if (!button) return;

  if (button.disabled) return;

  button.disabled = true;

  const text = button.querySelector(".sns-btn-text");

  if (text) {
    text.innerText = "Adding...";
  }

  const id = button.dataset.id;

  try {

    const drawer = document.querySelector("cart-drawer");

    const body = {
      items: [
        {
          id: Number(id),
          quantity: 1
        }
      ]
    };

    if (drawer && drawer.getSectionsToRender) {

      body.sections = drawer
        .getSectionsToRender()
        .map(section => section.id);

      body.sections_url = window.location.pathname;

    }

    const response = await fetch("/cart/add.js", {

      method: "POST",

      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },

      body: JSON.stringify(body)

    });

    const data = await response.json();

    if (!response.ok) {

      throw new Error(
        data.description || "Unable to add product"
      );

    }


    /* Render Shopify drawer */

    if (
      drawer &&
      drawer.renderContents &&
      data.sections
    ) {

      drawer.renderContents(data);

    } else {

      location.reload();

      return;

    }
    
    if (text) {
      text.innerText = "✓ Added";
    }

    button.classList.add("sns-added");


  } catch (error) {

    console.error(
      "SNS: Add to cart failed:",
      error
    );

    if (text) {
      text.innerText = "+ Add";
    }

    alert("Unable to add product.");

  }


  setTimeout(() => {

    button.disabled = false;

    if (text) {
      text.innerText = "+ Add";
    }

    button.classList.remove("sns-added");

  }, 1200);

});


/* =========================================================
   SHOPIFY CART DRAWER RE-RENDER SUPPORT
   ========================================================= */

document.addEventListener(
  "sns:drawerRendered",
  () => {

    setTimeout(() => {

      loadSuggestedProducts();

    }, 150);

  }
);


/* =========================================================
   SHOPIFY SECTION LOAD SUPPORT
   ========================================================= */

document.addEventListener(
  "shopify:section:load",
  () => {

    setTimeout(() => {

      loadSuggestedProducts();

    }, 200);

  }
);